import { render, staticRenderFns } from "./DetailsLoaderAnimatedIcon.vue?vue&type=template&id=1214fcfd&scoped=true"
import script from "./DetailsLoaderAnimatedIcon.vue?vue&type=script&lang=js"
export * from "./DetailsLoaderAnimatedIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1214fcfd",
  null
  
)

export default component.exports